export enum ConnectionState {
  CLOSED,
  CONNECTING,
  CONNECTED,
  DISCONNECTED
}
